// Single person, used on the "your timesheet" chip when an approver's own sheet appears in their list.
// Decorative — the control it sits in carries the accessible name, so the glyph
// is aria-hidden. Size via CSS font-size (renders at 1em); color via currentColor.
export function UserIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <circle cx="12" cy="8" r="3.8" />
      <path d="M4.8 20.2a7.2 7.2 0 0 1 14.4 0" />
    </svg>
  );
}
